__turbopack_context__.v({
  "badge": "BentoEcosystem-module__Qtwvya__badge",
  "bentoCard": "BentoEcosystem-module__Qtwvya__bentoCard",
  "bentoGrid": "BentoEcosystem-module__Qtwvya__bentoGrid",
  "bentoHeader": "BentoEcosystem-module__Qtwvya__bentoHeader",
  "bentoSection": "BentoEcosystem-module__Qtwvya__bentoSection",
  "block2x2": "BentoEcosystem-module__Qtwvya__block2x2",
  "cardDesc": "BentoEcosystem-module__Qtwvya__cardDesc",
  "cardIcon": "BentoEcosystem-module__Qtwvya__cardIcon",
  "cardTitle": "BentoEcosystem-module__Qtwvya__cardTitle",
  "dropAndFit": "BentoEcosystem-module__Qtwvya__dropAndFit",
  "inView": "BentoEcosystem-module__Qtwvya__inView",
  "rect1x2": "BentoEcosystem-module__Qtwvya__rect1x2",
  "rect2x1": "BentoEcosystem-module__Qtwvya__rect2x1",
  "rect3x1": "BentoEcosystem-module__Qtwvya__rect3x1",
  "square1x1": "BentoEcosystem-module__Qtwvya__square1x1",
  "subtitle": "BentoEcosystem-module__Qtwvya__subtitle",
  "title": "BentoEcosystem-module__Qtwvya__title",
  "titleHighlight": "BentoEcosystem-module__Qtwvya__titleHighlight",
});
